import React from 'react';
import PropTypes from 'prop-types';
import DownloadIcon from '@material-ui/icons/CloudDownload';
import Tooltip from '@ublend-npm/react-tooltip';

import {
  Container,
  CSVButton,
  Loader,
  LoaderContainer,
} from './ExportButtons.styled';

import Button from '$components/Button';

const ExportButtons = ({
  studentsWithGrades,
  totalStudents,
  onCSVDownload,
  onExportToSRS,
  isInitiatingExport,
  isGeneratingCsv,
}) => (
  <Container>
    <Tooltip title="Download all grades as a CSV file" position="top">
      <CSVButton>
        <Button
          size="iconLarge"
          look="iconTransparent"
          onClick={onCSVDownload}
          label="Download csv"
          disabled={isGeneratingCsv}
        >
          <DownloadIcon />
        </Button>
      </CSVButton>
    </Tooltip>
    <Button
      look="purple"
      size="large"
      onClick={onExportToSRS}
      disabled={isInitiatingExport}
      label="Export"
    >
      {isInitiatingExport ? (
        <LoaderContainer>
          <Loader size={18} />
        </LoaderContainer>
      ) : (
        `Export ${studentsWithGrades}/${totalStudents}`
      )}
    </Button>
  </Container>
);

ExportButtons.propTypes = {
  totalStudents: PropTypes.number.isRequired,
  studentsWithGrades: PropTypes.number.isRequired,
  onExportToSRS: PropTypes.func.isRequired,
  onCSVDownload: PropTypes.func.isRequired,
  isInitiatingExport: PropTypes.bool,
  isGeneratingCsv: PropTypes.bool,
};

ExportButtons.defaultProps = {
  isInitiatingExport: false,
  isGeneratingCsv: false,
};

export default ExportButtons;
